module.exports = __webpack_public_path__ + "6724d10bc722a5e816dd0d43cc9bef03.png";